import get from 'lodash-es/get'
import * as React from 'react'

import { formatClassfication } from '../../../../../../common/utils/searchResultFormator'
import { IMatch } from '../../../../../../typings/searchResults'
import Highlighter from '../../../../../shared/components/highlighter'

import * as styles from './header.module.css'

interface IProps {
  item: IMatch
  rank: number
  onItemLinkClick: React.EventHandler<any>
  term: string
  showCategory: boolean
}

const Header = ({
  item,
  rank,
  term,
  onItemLinkClick,
  showCategory
}: IProps) => {
  const { url, name, author_url, author_username } = item

  return (
    <div className={styles.root}>
      <h3>
        <a
          href={`${url}?s_rank=${rank}`}
          onClick={onItemLinkClick}
          className={styles.itemName}
          tabIndex={0}
        >
          <Highlighter background keywords={term.split(' ')}>
            {name}
          </Highlighter>
        </a>
      </h3>
      <div className={styles.author}>
        <i> by </i>
        <a className={styles.link} href={author_url.toLowerCase()}>
          {author_username}
        </a>
      </div>
      {showCategory ? (
        <span className={styles.category}>
          {formatClassfication(item.classification)}
        </span>
      ) : null}
    </div>
  )
}

export default Header
